export default __webpack_public_path__ + "static/media/misty.917f1d8c.png";